import { useQuery } from "react-query";
import { ImagesType } from "./type";
import { fetchServer } from "@features/utils";

export interface RelatedImagesResponse {
  originalImage: ImagesType;
  parentImage: ImagesType | null;
  pathToTarget: string[];
  siblingGroups: Record<string, ImagesType[]>;
  immediateChildren: ImagesType[];
  hasUpcomingImages: boolean;
}

export const useRelatedImages = (imageId: string) => {
  return useQuery<RelatedImagesResponse>(
    ["images", "related", imageId],
    async () =>
      await fetchServer<RelatedImagesResponse>(
        `/api/images/${imageId}/related`
      ),
    {
      enabled: !!imageId,
      staleTime: 30000, // 30 seconds
    }
  );
};
